import AppContext from "AppContext";
import GeneralForm from "components/GeneralForm";
import { useContext } from "react";
import { Table } from "reactstrap";

export default function Dados({ data, onChange, formConfig, edit }) {
  const { state } = useContext(AppContext)
  return (
    <>
      <GeneralForm
        config={formConfig}
        data={data}
        onChange={onChange}
        disabled={!edit}
      />
      <h3>Histórico</h3>
      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">Data</th>
            <th scope="col">Descrição</th>
            <th scope="col">Usuário</th>
          </tr>
        </thead>
        <tbody>
          {data.historico?.length == 0 && (
            <tr>
              <td colSpan={3} className="text-center">Nenhum registro</td>
            </tr>
          )}
          {data.historico?.map(el => (
            <>
                <tr key={el.id}>
                  <td>{el.dataFmt}</td>
                  <td>{el.descricao}</td>
                  <td>{el.usuario}</td>
                </tr>
            </>
          ))}
        </tbody>
      </Table>
    </>
  )
}